import { useEffect, useState } from "react";
import axios from "axios";
import { Trash2, Mail } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const getHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("bct_token")}` });

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);

  const load = () => {
    axios.get(`${API}/api/admin/messages`, { headers: getHeaders(), withCredentials: true }).then((r) => setMessages(r.data));
  };

  useEffect(() => { load(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Bu mesajı silmek istediğinize emin misiniz?")) return;
    await axios.delete(`${API}/api/admin/messages/${id}`, { headers: getHeaders(), withCredentials: true });
    load();
  };

  return (
    <div data-testid="admin-messages">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: "Outfit" }}>İletişim Mesajları</h1>
        <span className="text-sm text-slate-500">{messages.length} mesaj</span>
      </div>

      <div className="space-y-3">
        {messages.map((m) => (
          <div key={m.id} className="bg-[#161923] border border-white/5 rounded-xl p-5" data-testid={`message-${m.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex items-start gap-3 min-w-0">
                <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center flex-shrink-0">
                  <Mail size={16} className="text-purple-400" />
                </div>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <p className="text-white font-medium text-sm">{m.name}</p>
                    <span className="text-slate-600 text-xs">|</span>
                    <a href={`mailto:${m.email}`} className="text-[#FF5A00] text-xs hover:underline">{m.email}</a>
                    {m.phone && <span className="text-slate-500 text-xs">{m.phone}</span>}
                  </div>
                  <p className="text-slate-400 text-sm leading-relaxed">{m.message}</p>
                  <p className="text-slate-600 text-xs mt-2">
                    {new Date(m.created_at).toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" })}
                  </p>
                </div>
              </div>
              <button onClick={() => handleDelete(m.id)} className="p-2 text-slate-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-colors flex-shrink-0" data-testid={`delete-message-${m.id}`}>
                <Trash2 size={14} />
              </button>
            </div>
          </div>
        ))}
        {messages.length === 0 && (
          <div className="bg-[#161923] border border-white/5 rounded-xl p-12 text-center text-slate-500">
            Henüz mesaj yok
          </div>
        )}
      </div>
    </div>
  );
}
